/**
 * Common menu component prop generation methods used when building menu navigation
 * referenced server side in com.foretees.api.records.vueApp.enums.PropGen
 */

import {helpers} from '@/ft-vue-core'

const {ftAPI} = helpers

function clubMoment () {
  return ftAPI().clubMoment()
}

export default {
  standardItem: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone
  }),
  standardItemCurrent: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    listFilter: [
      {field: 'disabled', operator: 'EQUAL', values: [false]}
    ]
  }),
  reservationsToday: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    eventId: route.query.eventId,
    minFilterDateTime: clubMoment().format('YYYY-MM-DD 00:00:00'),
    maxFilterDateTime: clubMoment().format('YYYY-MM-DD 23:59:59'),
    listFilter: [{field: 'dateTime', operator: 'BETWEEN', values: [clubMoment().format('YYYY-MM-DD 00:00:00'), clubMoment().format('YYYY-MM-DD 23:59:59')]}]
  }),
  reservationsUpcoming: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    eventId: route.query.eventId,
    minFilterDateTime: clubMoment().format('YYYY-MM-DD 00:00:00'),
    listFilter: [{field: 'dateTime', operator: 'GREATER_OR_EQUAL', values: [clubMoment().format('YYYY-MM-DD 00:00:00')]}]
  }),
  reservationsUpcomingEvent: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    eventId: route.query.eventId,
    minFilterDateTime: clubMoment().format('YYYY-MM-DD 00:00:00'),
    listFilter: [
      {field: 'dateTime', operator: 'GREATER_OR_EQUAL', values: [clubMoment().format('YYYY-MM-DD 00:00:00')]},
      {field: 'eventId', operator: 'IS_NOT_NULL'}
    ]
  }),
  reservationsUpcomingDining: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    eventId: route.query.eventId,
    minFilterDateTime: clubMoment().format('YYYY-MM-DD 00:00:00'),
    listFilter: [
      {field: 'dateTime', operator: 'GREATER_OR_EQUAL', values: [clubMoment().format('YYYY-MM-DD 00:00:00')]},
      {field: 'eventId', operator: 'IS_NULL'}
    ]
  }),
  reservationsWaitlist: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    eventId: route.query.eventId,
    showWaitlist: true,
    minFilterDateTime: clubMoment().format('YYYY-MM-DD 00:00:00'),
    showColumns: {created: true, confirmationStatus: false},
    listFilter: [{field: 'dateTime', operator: 'GREATER_OR_EQUAL', values: [clubMoment().format('YYYY-MM-DD 00:00:00')]}]
  }),
  reservationsUnconfirmed: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    eventId: route.query.eventId,
    showColumns: {confirmationStatus: false},
    listFilter: [
      {field: 'dateTime', operator: 'GREATER_OR_EQUAL', values: [clubMoment().format('YYYY-MM-DD 00:00:00')]},
      {field: 'confirmationStatusId', operator: 'IS_NULL'}
    ]
  }),
  reservationsPast: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    eventId: route.query.eventId,
    maxFilterDateTime: clubMoment().subtract(1, 'days').format('YYYY-MM-DD 23:59:59'),
    listFilter: [{field: 'dateTime', operator: 'LESS_THAN', values: [clubMoment().format('YYYY-MM-DD')]}],
    propListFilter: {
      listingSortOrderId: 1, // Newest first
      searchFilterId: 'past'
    }
  }),
  reservationsAll: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    eventId: route.query.eventId,
    showWaitlist: null, // Show waitlisted or non-waitlisted
    propListFilter: {
      listingSortOrderId: 1, // Newest first
      searchFilterId: 'all'
    }
  }),
  reservationsIssues: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    eventId: route.query.eventId,
    showWaitlist: null, // Shows waitlist and non-waitlist
    listFilter: [{field: 'issues', operator: 'IS_NOT_NULL'}]
  }),
  reservationsAdd: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    eventId: route.query.eventId,
    isWalkin: route.query.walkin
  }),
  reservationsFiltered: (route) => {
    let mealPeriodIds
    if (route.query.mpIds) {
      try {
        mealPeriodIds = JSON.parse(route.query.mpIds).filter(mpid => !isNaN(mpid))
      } catch (e) {
        mealPeriodIds = undefined
      }
    } else if (route.query.mpId && !isNaN(route.query.mpId)) {
      mealPeriodIds = [parseInt(route.query.mpId, 10)]
    }
    const props = {
      id: route.query.id,
      showId: route.query.showId,
      cloneId: route.query.clone,
      eventId: route.query.eventId,
      propListFilter: {
        date: route.query.date,
        eventName: route.query.eventName,
        // mealPeriodId: route.query.mpId ? parseInt(route.query.mpId, 10) : undefined,
        mealPeriodIds: mealPeriodIds,
        searchFilterId: route.query.searchId
      },
      date: route.query.date
    }
    switch (route.query.waitlist) {
    case 'any':
      props.showWaitlist = null // Show both waitlisted and not waitlisted
      break
    case undefined:
    case 'none':
      props.showWaitlist = false // Show only reservations
      break
    case '':
    case null:
    case 'only':
      props.showWaitlist = true // Show only waitlisted
      break
    }
    return props
  },
  reservationsSelected: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    eventId: route.query.eventId,
    listFilter (vue) {
      const ids = route.query.ids
      if (!ids) return
      const idList = ids.split(/\s*,\s*/)
      if (!idList.length) return
      return [{field: 'id', operator: 'IN', values: idList}]
    },
    listTitle: route.query.t
  }),
  eventsToday: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    listFilter: [{field: 'date', operator: 'EQUAL', values: [clubMoment().format('YYYY-MM-DD')]}],
    listSortOrder: ['date:ASC', 'startTime:ASC', 'name:ASC']
  }),
  eventsUpcoming: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    listFilter: [{field: 'date', operator: 'GREATER_OR_EQUAL', values: [clubMoment().format('YYYY-MM-DD')]}],
    listSortOrder: ['date:ASC', 'startTime:ASC']
  }),
  eventsPast: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    listFilter: [{field: 'date', operator: 'LESS_THAN', values: [clubMoment().format('YYYY-MM-DD')]}],
    listSortOrder: ['date:ASC', 'startTime:ASC', 'name:ASC']
  }),
  eventsAll: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    listSortOrder: ['name:ASC', 'date:ASC', 'startTime:ASC']
  }),
  eventsRecurring: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    baseEventId: route.query.beid
  }),
  eventsRecurringEdit: (route) => ({
    value: route.query.id,
    cloneId: route.query.clone,
    baseEventId: route.query.beid
  }),
  blockersCurrent: (route) => ({
    id: route.query.id,
    showId: route.query.showId,
    cloneId: route.query.clone,
    listFilter: [
      {field: 'startDate', operator: 'GREATER_OR_EQUAL', values: [clubMoment().format('YYYY-MM-DD')]},
      {field: 'disabled', operator: 'EQUAL', values: [false]}
    ]
  }),
  legacyIframe: (route) => {
    const servlet = route.query.servlet || route.path.split(/\//).pop()
    const parms = Object.entries(route.query).reduce((a, [key, value]) => {
      if (!key.match(/^servlet$/)) {
        a.push({parm: key, value: value})
      }
      return a
    }, [])
    return {
      servlet: servlet,
      parms: parms,
      cloneId: route.query.clone,
      listFilter: [
        {field: 'startDate', operator: 'GREATER_OR_EQUAL', values: [clubMoment().format('YYYY-MM-DD')]},
        {field: 'disabled', operator: 'EQUAL', values: [false]}
      ]
    }
  },
}



